import React, { useEffect, useState, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
  useFilters,
} from "../../components/panel/panel.jsx";
import Table from "../../components/common/Table.jsx";
import { findInmatesActions } from "../../_store";
import NotificationService from "../../ui/ui-modal-notification.js";
import { ReactNotifications } from "react-notifications-component";
import relationshipSchema from "../../validation/findInmatesconnectSchema.js";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup.jsx";
import { Modal } from "bootstrap";
import TableForContacts from "../Mycontacts/TableForContacts.jsx";
import FindInmatesTableNew from "./FindInmatesTableNew.jsx";
import translations from '../../config/TranslateFile.jsx'
import { EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import { getStoredValue } from "../../_helpers/storagehelper.js";

const FindInmatesTable = ({ findInmate, setIsShowSearchResult }) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const findInmates = location?.state?.findInmates || findInmate || {};
  const [errorMessage, setErrorMessage] = useState({});
  const [isPaymentModal, setPaymentModal] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10); // <== new
  const [selectedRow, setSelectedRow] = useState({}); // State to store selected row data
  const [inmateDetail, setInmateDetail] = useState({
    relationship: "",
    userID: getStoredValue("userID"),
    action: 1,
    isSALoginAsPU: 0,
  });
  const currentLang = translations();
  const {
    PublicUserSearchInmateResponse,
    PublicInmateConnectionRequestResponse,
  } = useSelector((state) => state.findInmates);
  // useEffect(() => {
  //     dispatch(findInmatesActions.PublicUserSearchInmate(findInmates ));
  // }, [dispatch]);
  const [inviteInmateMsg, setInviteInmateMsg] = useState("");
  const [isInviteInmateModal, setIsInviteInmateModal] = useState(false);


  // You can calculate total pages and remainder in the parent now:
  useEffect(() => {
    const totalPages = Math.ceil(
      PublicUserSearchInmateResponse.length / rowsPerPage
    );
    const remainder = PublicUserSearchInmateResponse.length % rowsPerPage;

    if (remainder === 0) {
      setTablePage(1); // reset if exact fit
    } else if (tablePage > totalPages) {
      setTablePage(totalPages || 1);
    }
  }, [PublicUserSearchInmateResponse.length, rowsPerPage]);

  const columns = [
    { name: currentLang?.InmateID, accessor: "InmateNumber" },
    { name: currentLang?.FirstName, accessor: "FirstName" },
    { name: currentLang?.LastName, accessor: "LastName" },
    {
      name: currentLang?.DOB,
      accessor: "DOB"
    },
    {
      name: currentLang?.FacilityLocation,
      accessor: "FacilityLocation"
    },
    {
      name: currentLang?.Action,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <div
              className="btn btn-primary shadow btn-xs sharp me-1"
              title={currentLang?.buttons?.AddToContacts}
              data-bs-toggle="modal"
              data-bs-target="#modalDialog1"
              onClick={() => handleAddToContacts(row)}
            >
              <i class="fa fa-user-plus"></i>
            </div>
          </>
        );
      },
    },
  ];
  const col = useMemo(() => columns, []);

  const handleAddToContacts = (row) => {
    const newFormData = {
      FacilityCode: row?.FacilityCode,
      InmateID: row?.InmateID,
      InmateName: row?.InmateFullName,
      DOB: row?.DOB,
      inmateResidentID: row?.InmateNumber,
      inmatesId: row?.InmateID,
      facilityID: row?.FacilityID,
      FacilityName: row?.FacilityName,
    };
    const infoMessage = "Find Inmates - Selected Inmate from Gridview to Add Contact (Inmate ID - " + row?.InmateID + " ) ";
    const redirectURL = `Show Popup to Enter Relationship `;
    EventLog(dispatch, infoMessage, redirectURL)
    document
      .querySelector(`input[name=relationship]`)
      ?.classList.remove("input-error");
    setErrorMessage({});
    setSelectedRow(newFormData);
  };
  // Handle input change
  const handleChange1 = (e) => {
    const { name, value } = e.target;

    // Allow only alphabetic characters and spaces (no filtering of spaces)
    let updatedValue = value.replace(/[^a-zA-Z\s]/g, ""); // Remove non-alphabet characters, but allow spaces

    // Update state for the form input field
    setInmateDetail((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage({});

    // Clear existing input-error classes
    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }

    const infoMessage = "Find Inmate - Added Contact to My Contacts list ( Inmate ID - " + inmateDetail.relationship + " ) ";
    const redirectURL = `---`;
    EventLog(dispatch, infoMessage, redirectURL);

    const { error } = relationshipSchema(inmateDetail);

    if (error?.details) {
      error?.details.forEach((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [e?.path[0]]: e?.message,
        }));
        document
          .querySelector(`input[name=${path[0]}]`)
          ?.classList.add("input-error");
      });
      return;
    } else {
      // Close the modal first before dispatching
      const modalElement = document.getElementById("modalDialog1");
      const modalInstance = Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }

      setPaymentModal(false);

      // Now dispatch the action after closing the modal
      const mergedInmateDetail = {
        ...inmateDetail,
        ...selectedRow,
      };

      dispatch(
        findInmatesActions.PublicInmateConnectionRequest(mergedInmateDetail)
      );

      setInmateDetail({
        ...inmateDetail,
        relationship: "", // Clear only the relationship field
      });
    }
  };

  // useEffect(() => {
  //   dispatch(findInmatesActions.PublicUserSearchInmate(findInmates)).then((x) => {
  //     const infoMessage = `Bind Inmates - Find Inmate`;
  //     const redirectURL = `---`;
  //     const Response = JSON.stringify(x?.payload)
  //     const Status = "Inmates Count - " + x?.payload?.length;
  //     EventLog(dispatch, infoMessage, redirectURL, Response, Status);
  //   })
  // }, [dispatch, findInmates, navigate]);

  useEffect(() => {
    if (PublicInmateConnectionRequestResponse === 1) {
      dispatch(findInmatesActions.PublicUserSearchInmate(findInmates)).then((x) => {
        const infoMessage = `Bind Inmates - Find Inmate`;
        const redirectURL = `---`;
        const Response = JSON.stringify(x?.payload)
        const Status = "Inmates Count - " + x?.payload?.length;
        EventLog(dispatch, infoMessage, redirectURL, Response, Status);
      })
      dispatch(findInmatesActions.clearEmailResponse());
      NotificationService({
        title: currentLang?.Success,
        message: currentLang?.FindInmatePopContent?.Request_sent_Success,
        type: "success", // can be 'success', 'danger', 'info', 'warning'
      });
      //setTablePage(1);
    }

    // dispatch(findInmatesActions.PublicUserSearchInmate(findInmates)).then((x => {
    //   const infoMessage = `Bind Inmates - Find Inmate`;
    //   const redirectURL = `---`;
    //   const Response = JSON.stringify(x?.payload);
    //   const Status = "Inmates Count - " + x?.payload?.length;
    //   EventLog(dispatch, infoMessage, redirectURL, Response, Status);
    // }))
    setPaymentModal(false);
  }, [PublicInmateConnectionRequestResponse]);

  // Transfer Fund - popup close function
  const closeModal = () => {
    setPaymentModal(false);

    // Manually remove the modal's backdrop if it's still present
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove(); // Remove the backdrop
    }

    // Also make sure the body class is cleaned up
    document.body.classList.remove("modal-open");
    document.body.style = "";
  };
  const relationshipCancelClick = () => {
    dispatch(findInmatesActions.clearEmailResponse());
    setInmateDetail(inmateDetail);
    setErrorMessage({});
    closeModal();
    setPaymentModal(false);
    setInmateDetail({
      ...inmateDetail,
      relationship: "", // Clear only the relationship field
    });
  };


  const handleChanges = () => {
    navigate("/public/FindInmates", { state: { findInmates } });
    storeCurrentRoute("/public/FindInmates", { state: { findInmates } });
  };
  useEffect(() => {
    if (PublicInmateConnectionRequestResponse !== undefined && PublicInmateConnectionRequestResponse !== null && PublicInmateConnectionRequestResponse.length !== 0) {
      if (PublicInmateConnectionRequestResponse === -6) {
        dispatch(findInmatesActions.clearEmailResponse());
        setIsInviteInmateModal(true);
        setInviteInmateMsg("The permission to create connection with the chosen contact has been restricted");
      }
    }
  }, [PublicInmateConnectionRequestResponse]);

  return (
    <div>
      <ReactNotifications />
      <div className="h-100 d-flex justify-content-center align-items-center">
        <div className="card w-100 border-radius-all shadow-sm mb-5">
          <div className="card-body">
            {PublicUserSearchInmateResponse?.length > 0 ? <div>
              <FindInmatesTableNew
                columns={columns}
                data={PublicUserSearchInmateResponse?.length > 0 ? PublicUserSearchInmateResponse : []}
                showSearch={true}
                page={tablePage}
                onPageChange={setTablePage}
                onRowsPerPageChange={setRowsPerPage}
              />
            </div> :
              <div className="alert-light-red mb-3 font-size-16 p-3 text-center">
                {currentLang?.info?.NoResult}
              </div>
            }
          </div>
        </div>
      </div>

      {/* ---------- Popup for Add Relationship--------------------- */}
      <div
        className={`modal fade ${isPaymentModal ? "show" : ""}`} // Add 'show' class based on modal state
        id="modalDialog1"
        tabIndex="-1"
        aria-labelledby="modalDialog1"
        aria-hidden={!isPaymentModal}
        data-bs-backdrop="static"
        style={{ display: isPaymentModal ? "block" : "none" }} // Control visibility with inline styles
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{currentLang?.FindInmate?.Add_Relationship}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                backdrop="static"
                onClick={() => setPaymentModal(false)}
              ></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <h5 className="mb-4 text-default-red font-size-14">
                  {currentLang?.FindInmate?.Add_Relationship_Content}
                </h5>
                <div className="row mb-3">
                  <label className="form-label col-form-label fw-300 font-size-15 col-md-4">
                    {currentLang?.FindInmate?.Facility}
                  </label>
                  <div className="col-md-8">
                    <p className="mb-0 col-form-label">
                      {selectedRow?.FacilityName}
                    </p>
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="form-label col-form-label fw-300 font-size-15 col-md-4">
                    {currentLang?.FindInmate?.Inmate_ID}
                  </label>
                  <div className="col-md-8">
                    <p className="mb-0 col-form-label">
                      {selectedRow.inmateResidentID}
                    </p>
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="form-label col-form-label fw-300 font-size-15 col-md-4">
                    {currentLang?.FindInmate?.Inmate_Name}
                  </label>
                  <div className="col-md-8">
                    <p className="mb-0 col-form-label">
                      {selectedRow.InmateName}
                    </p>
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="form-label col-form-label fw-300 font-size-15 col-md-4">
                    {currentLang?.FindInmate?.Dob}
                  </label>
                  <div className="col-md-4">
                    <p className="mb-0 col-form-label">{selectedRow.DOB}</p>
                  </div>
                </div>
                <div className="row mb-3">
                  <label className="form-label col-form-label fw-300 font-size-15 col-md-4">
                    <span className="text-default-red">*</span>{currentLang?.FindInmate?.Your_Relationship}
                  </label>
                  <div className="col-md-8">
                    <input
                      type="text"
                      name="relationship" // Ensure name matches the state key
                      className={`form-control`}
                      value={inmateDetail.relationship} // Controlled input value
                      onChange={handleChange1} // Call handleChange1 when input value changes
                      placeholder={currentLang?.labels?.Enter_Relationship}
                      autoComplete="off"
                      maxLength="20"
                    // onInput={(e) => {
                    //   e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Allow only alphabets and spaces
                    // }}
                    />

                    {errorMessage.relationship && (
                      <div className="text-danger">
                        {errorMessage.relationship}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={relationshipCancelClick}
                >
                  {currentLang?.buttons?.Cancel}
                </button>
                <button type="submit" className="btn btn-success">
                  {currentLang?.buttons?.AddToContacts}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={isInviteInmateModal}
        onHide={() => setIsInviteInmateModal(false)}
        onConfirm={() => setIsInviteInmateModal(false)}
        title={currentLang?.Message}
        message={inviteInmateMsg}
        showCancelButton={false}
        onconfirmname={currentLang?.buttons?.OK}
      />
    </div>
  );
};

export default React.memo(FindInmatesTable);
